<template>
  <div>
    <section class="BasicHeader BasicHeader--default ContentPageHeader">
      <div class="Header-topNav">
        <div class="Header-topNav-inner">
          <div style="text-align: center">
            <a class="BlueOceanLogo">
              美签智能填表
            </a>
          </div>
        </div>
      </div>
    </section>
    <div v-if="!result.show">
      <DetailCreateTable ref="detailCreateTable" @emitInit="emitInit"
                         @completeDraft="handleComplete"></DetailCreateTable>
      <a-divider type="vertical" style="margin-top: 24px"/>
      <div class="footer">
        <a-row>
          <a-col :xs="{ span: 11, offset: 1 }" :sm="{ span: 11, offset: 1 }" :md="{ span: 11, offset: 1 }"
                 :lg="{ span: 11, offset: 1 }" :xl="{ span: 3, offset: 9 }" :xxl="{ span: 3, offset: 9 }">
            <a-button style="width: 100%;" @click="handleValid">
              验证
            </a-button>
          </a-col>
          <a-col :xs="{ span: 11, offset: 1 }" :sm="{ span: 11, offset: 1 }" :md="{ span: 11, offset: 1 }"
                 :lg="{ span: 11, offset: 1 }" :xl="{ span: 3, offset: 1 }" :xxl="{ span: 3, offset: 1 }">
            <a-button type="primary" style="width: 100%;" @click="handleSave">
              确定保存
            </a-button>
          </a-col>
        </a-row>
      </div>
      <a-back-top/>
    </div>
    <div v-if="result.show">
      <a-result :status="result.status"
                :title="result.title"
                :sub-title="result.subTitle">
      </a-result>
    </div>
  </div>
</template>

<script>

import DetailCreateTable from "@/components/usDs/DetailCreateTable";

export default {
  name: "DsLink",
  components: {DetailCreateTable},
  data() {
    return {
      result: {
        show: false,
        status: 'success',
        title: '已经成功提交!',
        subTitle: ''
      },
      id: '',
      url: {
        get: window._CONFIG['domainURL'] + "/power/usDs",
      }
    }
  },
  mounted() {
    document.title = "美国DS160填表";
    this.result.show = false;
    let url = window.location.href;
    const idMatch = url.match(/id=(\d+)/);
    if (idMatch) {
      this.id = idMatch[1];
    } else {
      this.result.show = true;
      this.result.status = 'error';
      this.result.title = '错误';
      this.result.subTitle = '外链错误，请获取最新的外链!';
      return;
    }
    this.result.subTitle = "订单编号: " + this.id + " 系统正在处理, 请耐心等待.";
    this.$refs.detailCreateTable.init(this.id, 'link');

    // setInterval(() => {
    //   this.$refs.detailCreateTable.handleSilentDraft();
    // }, 60 * 1000);
  },
  methods: {
    handleComplete(editProgress) {
      let that = this;
      that.$confirm({
        title: '温馨提示',
        content: editProgress === 100 ? '数据已经保存成功' : '数据已经保存成功，但是有必填项没有填，请您核对',
        okText: '确定',
        cancelText: '继续填',
        onOk() {
          that.result.show = true;
        },
        onCancel() {
        }
      });
    },
    handleSave() {
      this.$refs.detailCreateTable.handleDraft();
    },
    handleValid() {
      this.$refs.detailCreateTable.handleValid();
    },
    emitInit(data) {
      if (!(data.status === '开始' || data.status === '失败')) {
        this.result.show = true;
      }
    }
  }
}
</script>


<style scoped>

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;

  padding: 10px 16px;
  text-align: right;
  background: white;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
}

.ant-menu-horizontal > .ant-menu-item > a:hover, .ant-menu-horizontal > .ant-menu-item > a {
  color: white;
}

.Header-topNav-inner nav {
  display: flex;
  height: 100%;
}

.ContentPageHeader {
  color: white;
}

.BasicHeader--default {
  background: #4a90e2;
}

.BasicHeader {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.Header-topNav {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

.Header-topNav-inner {
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-right: 15px;
  padding-left: 15px;
}

.BlueOceanLogo, .BlueOceanLogo:hover {
  display: flex;
  color: white;
  text-decoration: none;
  align-items: center;
  font-size: 20px;
  position: relative;
  top: -1px;
  font-weight: bold
}

</style>
